// extracted by mini-css-extract-plugin
module.exports = {"root":"product-recommendations_root__KnpHL","stack":"product-recommendations_stack__tspN0","recommendationsBlock":"product-recommendations_recommendationsBlock__9mvVm"};